import { useEffect, useRef, useState } from "react";

// Returns true while the window is actively scrolling, then false `delay` ms after it stops.
export function useScrolling(delay = 220) {
  const [scrolling, setScrolling] = useState(false);
  const timer = useRef();
  useEffect(() => {
    const onScroll = () => {
      setScrolling(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setScrolling(false), delay);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(timer.current);
    };
  }, [delay]);
  return scrolling;
}
